/**
 * 관리자 캐시/매출 통계
 * ($j.Pages.Admin.CashStat / body data-page-name="CashStat")
 *
 * 월/년 회비 매출 + 캐시 충전/환전 추이 + 회비 납부경로 분해.
 */
export default class CashStat {
    constructor() {
        this.trendChart = null;
        this.palette = ['#0d6efd', '#198754', '#fd7e14', '#6610f2', '#20a8a8', '#dc3545'];
    }

    initialize() {
        $('#csRefresh').on('click', () => this._load(true));
        $('#csPeriod').on('change', () => this._load());
        this._load();
    }

    async _load(nocache = false) {
        try {
            const [unit, periods] = String($('#csPeriod').val()).split(':');
            const data = { unit, periods };
            if (nocache) data.nocache = 1;
            const res = await $.ajax({ url: '/adm/ajax/stat/cash/data', type: 'get', data });
            if (!res.ok) return;
            this._renderSummary(res.summary);
            this._renderTrend(res.trend);
            this._bars('#csBySource', res.by_source);
            if (res.cached_at) $('#csCachedAt').text(`집계 ${res.cached_at}`);
        } catch (e) {
            console.error('캐시/매출 통계 로드 실패', e);
        }
    }

    _renderSummary(s) {
        $('#csFee').text(this._won(s.fee));
        $('#csAvg').text(`${s.avg_label} ${this._won(s.avg_fee)}`);
        $('#csCharge').text(this._won(s.charge));
        $('#csWithdraw').text(this._won(s.withdraw));
        $('#csNet').text(this._won(s.net_cash)).removeClass('text-danger').toggleClass('text-danger', s.net_cash < 0);
    }

    _renderTrend(trend) {
        const ctx = document.getElementById('csTrendChart').getContext('2d');
        if (this.trendChart) this.trendChart.destroy();
        const labels = trend.map(t => this._fmt(t.bucket));
        this.trendChart = new Chart(ctx, {
            data: {
                labels,
                datasets: [
                    { type: 'bar', label: '충전', data: trend.map(t => t.charge), backgroundColor: '#0d6efd', order: 3 },
                    { type: 'bar', label: '환전', data: trend.map(t => t.withdraw), backgroundColor: '#dc3545', order: 3 },
                    { type: 'line', label: '회비 매출', data: trend.map(t => t.fee), borderColor: '#198754', backgroundColor: '#198754', tension: .25, order: 1, borderWidth: 3 },
                ]
            },
            options: {
                responsive: true, maintainAspectRatio: false,
                scales: { y: { beginAtZero: true, ticks: { callback: (v) => this._won(v) } } },
                plugins: {
                    tooltip: { callbacks: {
                        label: (c) => `${c.dataset.label}: ${this._won(c.raw)}`,
                        afterBody: (items) => trend[items[0].dataIndex].is_partial ? '(진행중)' : '',
                    } }
                }
            }
        });
    }

    _bars(sel, items) {
        if (!items || !items.length) { $(sel).html('<span class="text-muted small">없음</span>'); return; }
        const total = items.reduce((a, b) => a + b.count, 0);
        const max = Math.max(...items.map(i => i.count));
        const html = items.map((i, idx) => {
            const w = max > 0 ? Math.round(i.count / max * 100) : 0;
            const pct = total > 0 ? Math.round(i.count / total * 100) : 0;
            return `<div class="row-item">
                <span class="lbl">${i.label}</span>
                <span class="bar" style="width:${Math.max(w, 3)}%;background:${this.palette[idx % this.palette.length]}"></span>
                <span class="val">${this._won(i.count)} (${pct}%)</span>
            </div>`;
        }).join('');
        $(sel).html(html);
    }

    _won(n) {
        n = Number(n || 0);
        const neg = n < 0; n = Math.abs(n);
        let s;
        if (n >= 1e8) s = (n / 1e8).toFixed(1) + '억';
        else if (n >= 1e4) s = Math.round(n / 1e4).toLocaleString() + '만';
        else s = n.toLocaleString();
        return (neg ? '-' : '') + s;
    }

    _fmt(b) {
        const s = String(b);
        return s.length === 6 ? `${s.slice(2, 4)}.${s.slice(4)}` : s;
    }

    destroy() {
        if (this.trendChart) { this.trendChart.destroy(); this.trendChart = null; }
    }
}
